import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { BatchProcessModuleType } from 'src/app/enum/batch-processType';
import { DebitOrderNotificationService } from 'src/app/services/debit-order-notification.service';
import { ExcelService } from 'src/app/services/excel.service';
import { NotificationService } from 'src/app/services/notification-service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import Swal from 'sweetalert2';

import { DatePipe } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-portal-notifications',
  templateUrl: './portal-notifications.component.html',
  styleUrls: ['./portal-notifications.component.scss'],
   animations: [
              trigger('detailExpand', [
                  state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
                  state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
                  transition('expanded <=> collapsed', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
              ]),
          ],

})
export class PortalNotificationsComponent implements OnInit {
form:FormGroup
Exceluploadshow=false
filtershow=false
dataExcel: any = [];
excelColumns: string[];
data=[];
dataSource= new MatTableDataSource(this.data);
displayedColumns: string[] = [
  "CustomerNumber",
  "Name",
  "Type",
  "SentOn",
  "Status",
  "View",
]
BatchProcessType=BatchProcessModuleType;
  mindate: any;
  fileName: any;
  file: File;
  isFileSelected=false;
  FileExtention: any;
  maxdate: Date=new Date()


  constructor(
   private formBuilder:FormBuilder,
   private debitOrderNotificationService:DebitOrderNotificationService,
   private loaderService: LoaderService,
   private toastr: NotificationService,
   private excelService: ExcelService,
   private datePipe: DatePipe
  ) { }
  @ViewChild('startDatePicker') startDatePicker: MatDatepicker<Date>;
  @ViewChild('endDatePicker') endDatePicker: MatDatepicker<Date>;
  @ViewChild(MatPaginator,{static:true}) paginator:MatPaginator;

  ngOnInit(): void {
    this.form=this.formBuilder.group({
      startDate:[],
      endDate:[],
      AttachmentFileName:[],
      batchProcessModuleType:['2'],
    })
    this.gettabledata(null)
  }
  toggleExcelUpload(){
    this.Exceluploadshow=this.Exceluploadshow?false:true

  }
  toggleAdvancedFilter(){
    this.filtershow=this.filtershow?false:true


  }
  DatePicker(controlName: string, event: any, ): void {
    const control = this.form.get(controlName);



      if (controlName === 'startDate') {
        this.mindate = event.value;
      }


    console.log(this.form.value);
  }
  filter(){
    if(this.form.valid){
      let filterSearch={
        startDate:this.formatDate('startDate'),
        endDate:this.formatDate('endDate')
      }
      
      this.gettabledata(filterSearch)
    }
  }
  formatDate(controlName: string) {
    const control = this.form.get(controlName);
      const formattedDate = this.datePipe.transform(control.value, 'MM/dd/yyyy');
      return formattedDate;
  }
  gettabledata(data){
    debugger

    this.debitOrderNotificationService.getDebitOrderNotificationList(data).subscribe((result)=>{
      this.data=[]
      if(result)
      this.data=result.map(item=>({
        ...item,
        moduleType:this.modeltype(item.moduleType),
        processType:this.batchtype(item.processType),
      }))
      this.dataSource= new MatTableDataSource(this.data);
      this.dataSource.paginator=this.paginator;
        this.dataExcel=this.data;
    })
  }

  batchtype(status){
    switch (status) {
      case 1:
        return "New";
    case 2:
        return "In Progress";
    case 3:
        return "Success";
    case 4:
        return "Failed";
      default:
        return '';
    }
  }

  modeltype(status){
    switch (status) {
      case this.BatchProcessType.DORemainderExcelImport:
          return "Notification";
      case this.BatchProcessType.DOFailed:
          return "Unpaid Callback";
      case this.BatchProcessType.SuspendRemainderExcelImport:
          return "Suspend Notification";
      default:
          return "";
  }
  }
  selectFile() {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.style.display = 'none';
    document.body.appendChild(inputElement);
    inputElement.click();

    inputElement.addEventListener('change', async (event: any) => {
      const files: FileList = (event.target as HTMLInputElement).files;

      if (!files || files.length === 0) {
        Swal.fire('Warning', 'Please upload a file', 'warning');
        return;
      }
      if (files.length > 1) {
        Swal.fire('Warning', 'Please upload only one file at a time', 'warning');
        return;
      }

      this.file = files[0];
      this.fileName = this.file.name;
      const fileExtension = this.fileName.split('.').pop().toLowerCase();
      const validExtensions = ['csv', 'xlsx', 'xls'];
      const validMimeTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];

      const isValidExtension = validExtensions.includes(fileExtension);
      const isValidMimeType = validMimeTypes.includes(this.file.type);

      if (!isValidExtension || !isValidMimeType) {
        Swal.fire(
          'Warning',
          `Please upload a correct file format (csv, xlsx, xls)`,
          'warning'
        );
        this.fileName = '';
        this.isFileSelected = false;
        document.body.removeChild(inputElement);
        return;
      }
      this.FileExtention = fileExtension;
      this.isFileSelected = true;
      this.form.controls['AttachmentFileName'].setValue(this.fileName);
      console.log(this.file);
      document.body.removeChild(inputElement);
    });
  }

  reset() {
    const txt = 'Are you sure you want to delete?';
    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.fileName = '';
        this.isFileSelected = false;
        this.form.controls['AttachmentFileName'].setValue(this.fileName);
      }
    });
  }
  upload(){
    let formdata:FormData=new FormData();
    if(this.file){
    formdata.append('file',this.file);
    formdata.append('BatchProcessModuleType',this.form.value.batchProcessModuleType)
    this.debitOrderNotificationService.getFileUploaderInstance(formdata).subscribe((result)=>{
      if(!result){
        Swal.fire('Success',' Excel upload process started successfully. ','success');
      }
      else if(result=='Oops! Something went wrong'){
        Swal.fire('Error',' Unexpected error occurred,please try again!. ','error');

      }

    })
  }
}

  getStatusClass(status:string):string{
    switch (status) {
      case 'New':
        return 'bg-new';
      case 'In Progress':
        return 'bg-inprogress';
      case 'Success':
        return 'bg-Success';
      case 'Failed':
        return 'bg-failed';
      default:
        return '';
    }
  }
  download(id){
    this.debitOrderNotificationService.downloadFile(id).subscribe((data)=>{
      if (data != null) {
        const link = document.createElement("a");
        link.href = data.baseUrl + data.byteImage;
        link.download = `${data.filename}`; 
        link.click();
    }
    })
  }
  view(data){
    if(data.batchProcessId){
      this.debitOrderNotificationService.getSmsDetails(data.notificationId).subscribe((result)=>{
        if(result){
          Swal.fire('Notification Details',  data.client+'<br>'+ result.key +'<br>'+ result.value ,'info');
        }
      })
    }
  }

  clearFilter(){
    this.gettabledata(null);
    this.form.reset();
    this.isFileSelected = false;
  }

  exportAsXLSX(): void {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "S.No",
        'Customer Number',
        'Name',
        'Debit Order Type',
        'Sent On',
        'Status'

      ];
      exportData.forEach((a, index) => {
        let customerName = a.name;
        let maskedName = this.encryptionname(customerName);
        excelList.push({
          sno: ++index,
          'Customer Number':a.client,
          'Name':maskedName,
          'Debit Order Type':a.moduleType,
          'Sent On':a.creationTs,
          'Status':a.processType
        });
      });
      this.excelService.exportAsExcelFile(excelList, "DebitOrderNotification" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }
  encryptionname(name: string): string {
    const nameParts = name.split(" ");
    let maskedName = nameParts.map(part => {
      if (part.length > 2) {
        return part.substring(0, 2) + 'xxx';
      } else {
        return part;
      }
    }).join(" ");
    return maskedName;
  }
}
